import * as React from 'react';
import Box from '@mui/material/Box';
import { DataGridPro, GridColDef, GridValueGetterParams, GridColumnHeaderParams, GridRenderCellParams, GridValueSetterParams, GridEventListener, GridRowEditStopParams, GridSelectionModel, GridRowParams, useGridApiRef, GridCellEditStopReasons , GRID_CHECKBOX_SELECTION_COL_DEF, GridCallbackDetails, GridCellEditStopParams, GridCellEditCommitParams } from '@mui/x-data-grid-pro';
import { v4 as uuid } from 'uuid';
import { Filter, FilterType } from '../../filters/FilterTypes';
import { client } from '../../../utils/axios-client';
import { leadDataManagementEndpoint, leadEndpoints } from '../../../configs/endpoints';
import { Pagination } from 'src/types/common';
import { Lead } from './LeadDataGridStore';
import { Backdrop, Button, CircularProgress, Grid } from '@mui/material';
import _ from 'lodash';
import StatusColumn from './StatusColumn';
import ValidationColumn from './ValidationColumn';
import TextColumn from './TextColumn';
import { SelectOption } from 'src/types/common';
import { ApiResponseType } from '../../../types';
import OptionsLoader, { OptionsStore } from '../../common/OptionsLoader';
import CountryColumn from './column-components/CountryColumn';
import SourcesColumn from './column-components/SourcesColumn';
import FunctionsColumn from './column-components/FunctionsColumn';
import IndustryColumn from './column-components/IndustryColumn';
import RegionColumn from './column-components/RegionColumn';
import LevelsColumn from './column-components/LevelsColumn';
import LeadSearch from '../../filters/leads/LeadSearch';
import OwnersColumn from './column-components/OwnersColumn';
import ApplicationStore from '../../../stores/ApplicationStore';
import ExcelImportStore from './ExcelImportStore';
import LeadImportDialog from './LeadImportDialog';
import SimpleDialog from '../../common/SimpleDialog';
import RenderIf, { ClaimType, ClaimValue } from '../../common/RenderIf';
import SectionAppBar from '../../../v2/components/Section/SectionAppBar';
import CloseButton from '../../../v2/components/Button/CloseButton';


const columns: GridColDef[] = [
    {
        field: 'duplicates',
        headerName: 'Duplicate',
        width: 100,
        editable: false,

        renderCell: (params: GridRenderCellParams<Lead>) => (
            <StatusColumn lead={params.row} />)
    },
    {
        field: 'validation',
        headerName: 'Valid?',
        width: 80,
        editable: false,

        renderCell: (params: GridRenderCellParams<Lead>) => (<ValidationColumn lead={params.row} />)
    },
    {
        field: 'emailAddress',
        headerName: 'Email Address',
        width: 250,
        editable: true,
        renderCell: (params: GridRenderCellParams<Lead>) => (<TextColumn value={params.row.emailAddress} error={params.row.emailAddressError} />)
    },
    {
        field: 'firstName',
        width: 200,
        editable: true,
        renderHeader: (params: GridColumnHeaderParams) => (
            <strong>
                {'First Name '}
            </strong>
        ),
        renderCell: (params: GridRenderCellParams<Lead>) => (<TextColumn value={params.row.firstName} error={params.row.firstNameError} />)
    },
    {
        field: 'lastName',
        headerName: 'Last name',
        width: 200,
        editable: true,
        renderCell: (params: GridRenderCellParams<Lead>) => (<TextColumn value={params.row.lastName} error={params.row.lastNameError} />)
    },
    {
        field: 'company',
        width: 200,
        editable: true,
        renderHeader: (params: GridColumnHeaderParams) => (
            <strong>
                {'Company '}
            </strong>
        ),
        renderCell: (params: GridRenderCellParams<Lead>) => (<TextColumn value={params.row.company} error={params.row.companyError} />)
    },
    {
        field: 'jobTitle',
        headerName: 'Job Title',
        width: 200,
        editable: true,
        renderCell: (params: GridRenderCellParams<Lead>) => (<TextColumn value={params.row.jobTitle} error={params.row.jobTitleError} />)
    },
    {
        field: 'linkedIn',
        headerName: 'Linked In',
        width: 200,
        editable: true,
        renderCell: (params: GridRenderCellParams<Lead>) => (<TextColumn value={params.row.linkedIn} error={params.row.linkedInError} />)
    },
    {
        field: 'leadLevel',
        headerName: 'Lead Level',
        width: 350,
        editable: true,
        valueGetter: (params) => params.row.leadLevelId,
        //valueSetter: (params: GridValueSetterParams) => {
        //    params.value
        //    return {
        //        ...params.row, leadLevelId: params.value
        //    }
        //},
        renderEditCell: (params: GridRenderCellParams<Lead>) => (<LevelsColumn value={params.row.leadLevelId} id={params.row.id} />),
        renderCell: (params: GridRenderCellParams<Lead>) => (<TextColumn value={params.row.leadLevelName} error={params.row.leadLevelIdError} />)
    },
    {
        field: 'switchboard',
        headerName: 'Switchboard',
        width: 350,
        editable: true,
        renderCell: (params: GridRenderCellParams<Lead>) => (<TextColumn value={params.row.switchboard} error={params.row.switchboardError} />)
    },
    {
        field: 'phone',
        headerName: 'Phone',
        width: 350,
        editable: true,
        renderCell: (params: GridRenderCellParams<Lead>) => (<TextColumn value={params.row.phone} error={params.row.phoneError} />)
    },
    {
        field: 'mobile',
        headerName: 'Mobile',
        width: 350,
        editable: true,
        renderCell: (params: GridRenderCellParams<Lead>) => (<TextColumn value={params.row.mobile} error={params.row.mobileError} />)
    },
    {
        field: 'city',
        headerName: 'City',
        width: 350,
        editable: true,
        renderCell: (params: GridRenderCellParams<Lead>) => (<TextColumn value={params.row.city} error={params.row.cityError} />)
    },
    {
        field: 'province',
        headerName: 'Province',
        width: 350,
        editable: true,
        renderCell: (params: GridRenderCellParams<Lead>) => (<TextColumn value={params.row.province} error={params.row.provinceError} />)
    },
    {
        field: 'country',
        headerName: 'Country',
        width: 350,
        editable: true,
        valueGetter: (params) => params.row.countryId,
        //valueSetter: (params: GridValueSetterParams) => {
        //    params.value
        //    return {
        //        ...params.row, countryId: params.value
        //    }
        //},
        renderEditCell: (params: GridRenderCellParams<Lead>) => (<CountryColumn value={params.row.countryId} id={params.row.id} />),
        renderCell: (params: GridRenderCellParams<Lead>) => (<TextColumn value={params.row.countryName} error={params.row.countryIdError} />)
    },
    {
        field: 'leadSource',
        headerName: 'Lead Source',
        width: 350,
        editable: true,
        valueGetter: (params) => params.row.leadSourceId,
        //valueSetter: (params: GridValueSetterParams) => {
        //    params.value
        //    return {
        //        ...params.row, leadSourceId: params.value
        //    }
        //},
        renderEditCell: (params: GridRenderCellParams<Lead>) => (<SourcesColumn value={params.row.leadSourceId} id={params.row.id} />),
        renderCell: (params: GridRenderCellParams<Lead>) => (<TextColumn value={params.row.leadSourceName} error={params.row.leadSourceIdError} />)
    },
    {
        field: 'leadFunction',
        headerName: 'Lead Function',
        width: 350,
        editable: true,
        valueGetter: (params) => params.row.leadFunctionId,
        //valueSetter: (params: GridValueSetterParams) => {
        //    params.value
        //    return {
        //        ...params.row, leadFunctionId: params.value
        //    }
        //},
        renderEditCell: (params: GridRenderCellParams<Lead>) => (<FunctionsColumn value={params.row.leadFunctionId} id={params.row.id} />),
        renderCell: (params: GridRenderCellParams<Lead>) => (<TextColumn value={params.row.leadFunctionName} error={params.row.leadFunctionIdError} />)
    },
    {
        field: 'leadIndustry',
        headerName: 'Lead Industry',
        width: 350,
        editable: true,
        valueGetter: (params) => params.row.industryId,
        //valueSetter: (params: GridValueSetterParams) => {
        //    params.value
        //    return {
        //        ...params.row, leadIndustryId: params.value
        //    }
        //},
        renderEditCell: (params: GridRenderCellParams<Lead>) => (<IndustryColumn value={params.row.industryId} id={params.row.id} />),
        renderCell: (params: GridRenderCellParams<Lead>) => (<TextColumn value={params.row.industryName} error={params.row.industryIdError} />)
    },
    {
        field: 'leadRegion',
        headerName: 'Lead Region',
        width: 350,
        editable: true,
        valueGetter: (params) => params.row.addressRegionId,
        //valueSetter: (params: GridValueSetterParams) => {
        //    params.value
        //    return {
        //        ...params.row, leadRegionId: params.value
        //    }
        //},
        renderEditCell: (params: GridRenderCellParams<Lead>) => (<RegionColumn value={params.row.addressRegionId} id={params.row.id} />),
        renderCell: (params: GridRenderCellParams<Lead>) => (<TextColumn value={params.row.addressRegionName} error={params.row.addressRegionIdError} />)
    },
    {
        field: 'leadOwner',
        headerName: 'Lead Owner',
        width: 350,
        editable: true,
        valueGetter: (params) => params.row.leadOwnerId,
        //valueSetter: (params: GridValueSetterParams) => {
        //    params.value
        //    return {
        //        ...params.row, leadOwnerId: params.value
        //    }
        //},
        renderEditCell: (params: GridRenderCellParams<Lead>) => (<OwnersColumn value={params.row.leadOwnerId} id={params.row.id} />),
        renderCell: (params: GridRenderCellParams<Lead>) => (<TextColumn value={params.row.leadOwnerName} error={params.row.leadOwnerIdError} />)
    }
];

type Props = {
    onClose: () => void
}

const LeadDataGrid = ({ onClose }: Props) => {
    const apiRef = useGridApiRef();
    const rows = ExcelImportStore.useState(s => s.leads);
    const [numberOfRows, setNumberOfRows] = React.useState(10000);
    const [importColumns, setImportColumns] = React.useState([] as string[])
    const [leadImportDialogOpen, setLeadImportDialogOpen] = React.useState(false);
    const [leadImporting, setLeadImporting] = React.useState(false);
    const session = ExcelImportStore.useState(s => s.session);
    const [selectedLeadIds, setSelectedLeadIds] = React.useState<string[]>([]);
    const [missingColumns, setMissingColumns] = React.useState<string[]>([]);
    const sessionId = ExcelImportStore.useState(s => s.session.sessionId);
    const [loading, setLoading] = React.useState(false);

    const [filter, setFilter] = React.useState({
        id: uuid(),
        description: '',
        searchTerm: '',
        options: [],
        activityDate: 'today',
        filterType: FilterType.User
    } as Filter);

    React.useEffect(() => {
        setImportColumns(columns.filter(s => s.field !== 'duplicates' && s.field !== 'validation').map(s => s.field));
        loadLeads();
    }, [filter])

    const onFiltersChanged = (newFilter: Filter) => {
        setFilter(newFilter);
    }

    const loadLeads = async () => {
        const response = await client.post<Pagination<Lead>>(leadDataManagementEndpoint + '/getpaginated', { ...filter, sessionId: sessionId, pageNumber: 1, pageSize: numberOfRows });

        ExcelImportStore.update(s => {
            s.leads = response.data.items;
        })
    }

    const saveRecords = async (records: Lead[]) => {
        const response = await client.post<ApiResponseType>(leadDataManagementEndpoint + '/save', { records: records });

        if (response.data.succeeded) {
            console.log('saved');
        } else {
            alert('error');
        }
    }

    const onRowEditStop = async (params: GridRowEditStopParams) => {
        await saveRecords([...params.row]);
    }

    const processRowUpdate = async (newRow: Lead, oldRow: Lead) => {
        console.log(newRow);
        await saveRecords([newRow]);

        return newRow;
    }

    // Handle cell edit commit (called when cell edit is finished)
    const handleCellEditCommit: GridEventListener<'cellEditCommit'> = async (params: any) => {        
        const updatedRow = { ...rows.find((row) => row.id === params.id), [params.field]: params.value };
        await processRowUpdate(params.row as Lead, updatedRow as Lead);
    };

    const onSelectionModeChange = async (ids: GridSelectionModel, details: GridCallbackDetails) => {
        const selectedIds = ids.map(s => s.toString());
        setSelectedLeadIds(selectedIds);
    }

    const onImportLeads = async () => {
        setLeadImporting(true);
        setLeadImportDialogOpen(true);
    }

    const onLeadImportDialogClose = async (cancelled: boolean) => {
        if (leadImporting && !cancelled) {
            const response = await client.post<ApiResponseType>(leadDataManagementEndpoint + "/commit", { leadIds: selectedLeadIds, sessionId: session.sessionId });

            if (response.data.succeeded) {
                let leadsImported = 0;

                ExcelImportStore.update((s, o) => {
                    const tempRows = _.cloneDeep(o.leads.filter(s => selectedLeadIds.indexOf(s.id) === -1));

                    leadsImported = o.leads.length - tempRows.length;

                    s.leads = tempRows;
                })

                setSelectedLeadIds([]);

                ApplicationStore.update(s => {
                    s.snackbarMessage = `${leadsImported} leads imported into Nostra`;
                    s.snackbarOpen = true;
                });

            } else {
                alert('error occured');
            }
        }

        setLeadImportDialogOpen(false);
        setLeadImporting(false);
    }

    const onAddRow = () => {
        ExcelImportStore.update((s, o) => {
            const temp = _.cloneDeep(o.leads);

            temp.unshift({
                id: uuid(),
                sessionId: sessionId
            } as Lead);

            s.leads = temp;
        })
    }

    const onProcessRowUpdateError = (error: any) => {
        console.log("error", error);
    }

    return (
        <>
            <OptionsLoader>
                <Box sx={{ width: '100%', height: '100%' }}>
                    <SectionAppBar
                        title={`Lead Import: ${session.name}`}
                        subTitle={''}
                        buttons={
                            <>
                                <RenderIf claimType={ClaimType.LeadImport} claimValue={ClaimValue.ManualImport}>
                                    <Button size="small" variant="contained" onClick={onAddRow} sx={{ mr: 2 }}>Add Row</Button>
                                </RenderIf>
                                <Button size="small" variant="contained" onClick={onImportLeads} disabled={selectedLeadIds.length === 0}>Import Selected</Button>
                                <CloseButton color='secondary' onClick={onClose}>Close</CloseButton>
                            </>
                        }
                    />

                    <Grid container justifyContent="center" alignItems="center">
                        <Grid item xs={12} md={12}>
                            <LeadSearch onChange={onFiltersChanged} />
                        </Grid>
                    </Grid>

                    <DataGridPro
                        apiRef={apiRef}
                        rows={rows}
                        columns={columns}
                        pageSize={numberOfRows}
                        rowsPerPageOptions={[numberOfRows]}
                        onRowEditStop={onRowEditStop}
                        processRowUpdate={processRowUpdate}                
                        onProcessRowUpdateError={onProcessRowUpdateError}//                        onCellEditStop={handleCellEditCommit} // Handle blur event
                        checkboxSelection
                        disableSelectionOnClick
                        onSelectionModelChange={onSelectionModeChange}
                        isRowSelectable={(params: GridRowParams) => params.row.isValid}
                        experimentalFeatures={{ newEditingApi: true }}
                        pinnedColumns={{ left: [GRID_CHECKBOX_SELECTION_COL_DEF.field, 'duplicates', 'validation', 'emailAddress'] }}
                    />
                </Box>
                <Backdrop
                    sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                    open={loading}
                >
                    <CircularProgress color="inherit" />
                </Backdrop>
            </OptionsLoader >
            {leadImportDialogOpen && <SimpleDialog open={leadImportDialogOpen} onClose={() => setLeadImportDialogOpen(false)}>
                <LeadImportDialog importing={leadImportDialogOpen} onClose={onLeadImportDialogClose} />
            </SimpleDialog>}
        </>
    );
}

export { LeadDataGrid }
export default LeadDataGrid;
